import { BaseService } from "core/services";
import { TrackingCaseDocumentRouteService } from "application/tracking-case/services";

class TrackingCaseDocumentService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TrackingCaseDocumentRouteService());
    }
    
	submit(resource) {
        const url = this.routeService.submit(resource);
        return this.apiClient.put(url);
    }

    populate(resource) {
        const url = this.routeService.populate(resource);
        return this.apiClient.put(url);
    }
}

export default TrackingCaseDocumentService;